import { render, staticRenderFns } from "./CommunityGlobalSearch.vue?vue&type=template&id=410cc456"
import script from "./CommunityGlobalSearch.vue?vue&type=script&lang=js"
export * from "./CommunityGlobalSearch.vue?vue&type=script&lang=js"
import style0 from "./CommunityGlobalSearch.vue?vue&type=style&index=0&id=410cc456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports